<app-header></app-header>
<!-- <app-banner-enquiry-form></app-banner-enquiry-form> -->
<app-banner-enquiry-form [backgroundImageId]="'1'" [loanTypeId]='12' serviceName="financial planning"></app-banner-enquiry-form>

<!-- Hero Section with Get In Touch Form -->
<!-- <section class="form-section">
 
  <div class="row d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="col-md-7">
        <div class="card transparent-card">
            <h1>We help you to Achieve your Financial Goals</h1>
            <a href="/appointment" class="btn btn-orange small-button ">Schedule a Meeting</a>
        </div>
    </div>

    

    <div class="col-md-5">
      <div class="form-container">
        <h2>GET IN TOUCH</h2>
        <h3 class="slogan">Your journey to financial freedom starts here!</h3>
        <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()">
          <input type="text" formControlName="full_name" placeholder="Enter your Name" required>
          <input type="email" formControlName="email" placeholder="Enter your Email" required>
          <input type="tel" formControlName="phone" placeholder="Enter Phone Number" required>
          <input type="text" formControlName="enq_detail_msg" placeholder="Enter your Message" required>
          <button type="submit" [disabled]="!enquiryForm.valid">Submit</button>
        </form>
      </div>
    </div>
</div>
    

  
</section>

<!- Financial Planning Section -->
<div class="plan-section">
  <!-- Financial Planning Title Section -->
  <h2 class="plan-title">Financial Planning</h2>

  
    <p>
      <strong>Financial planning</strong> is a comprehensive process that involves analysing your 
      <strong>current financial situation</strong>, setting <strong>Financial goals</strong>, 
      and developing a plan to achieve those goals. It is a strategic approach to managing your 
      finances, considering your income, expenses, assets, liabilities, and future financial needs. 
      <strong>Financial planning</strong> is not just about budgeting or saving; it is about making 
      informed decisions to help you achieve your long-term goals and 
      <strong>secure your future</strong>.
    </p>
  

  



    <h3 class="important-heading">
      Understanding Your Financial Situation
      <div class="underline"></div>
    </h3>


      <p>
        The first step in <strong>Financial planning</strong> is to understand your 
        <strong>current financial situation</strong>. This involves assessing your income, expenses, 
        assets, and liabilities. It also involves understanding your 
        <strong>Financial goals</strong> and priorities. By understanding your 
        <strong>current financial situation</strong>, you can identify areas for improvement and 
        develop a plan to achieve your <strong>Financial goals</strong>.
      </p>
    


  <!-- Setting Financial Goals Section -->
  <section class="service-section">
    <!-- Text Content -->
    <div class="content order-md-1 order-2">
      <h2>Setting Financial Goals</h2>
      <p>
        The next step in <strong>Financial planning</strong> is to set <strong>Financial goals</strong>.
        This involves identifying what you want to achieve financially and setting specific, measurable,
        achievable, relevant, and time-bound (<strong>SMART</strong>) goals.
        <strong>Financial goals</strong> include saving for retirement, buying a home, paying off debt,
        or starting a business. By setting clear <strong>Financial goals</strong>, you can develop a
        plan to achieve those goals and track your progress over time.
      </p>
    </div>
  
    <!-- Image -->
    <div class="order-md-2 order-1">
      <img src="assets/24252760_goal_4-removebg-preview.png" alt="Setting Financial Goals">
    </div>
  </section>
  

  <!-- Developing a Financial Plan Section -->
  <section class="service-section">
    <img src="assets\budget-planning-people-analyzing-personal-corporate-budget-finance-accounting-calculation-financial-\budget_3.jpg" alt="Developing a Financial Plan">
    <div class="content">
      <h2>Developing a Financial Plan</h2>
      <p>
        Once you have identified your <strong>Financial goals</strong>, you should develop a financial plan. A financial plan is a detailed strategy for achieving your <strong>Financial goals</strong>. It includes a budget, an investment plan, a retirement plan, an estate plan, and a risk management plan. A <strong>Financial plan</strong> is tailored to your needs and circumstances and considers factors like age, income, expenses, assets, liabilities, and risk tolerance.
      </p>
    </div>
  </section>

  <!-- Implementing and Monitoring Section -->
 <!-- Implementing and Monitoring Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Implementing and Monitoring Your Plan</h2>
    <p>
      Once you have developed a <strong>financial plan</strong>, the next step is to implement it. This involves taking action to achieve your <strong>financial goals</strong>, such as saving money, investing in the stock market, or buying insurance. It also consists of monitoring your progress and adjusting your plan as needed. By regularly reviewing your financial plan and making adjustments as needed, you can stay on track to achieve your <strong>financial goals</strong> and secure your financial future.
    </p>
    <p>
      Financial planning is a strategic approach to managing your finances that includes analyzing your <strong>current financial situation</strong>, setting <strong>financial goals</strong>, and developing a plan to achieve those goals. It is not just about <strong>budgeting</strong> or saving; it's about making informed decisions to help you achieve your long-term goals and secure your future. You can achieve financial success and peace of mind by understanding your current financial situation, setting clear <strong>financial goals</strong>, developing a financial plan, and implementing and monitoring your plan.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets\budget-planning-people-analyzing-personal-corporate-budget-finance-accounting-calculation-financial-\21897174_benchmarking_5.jpg" alt="Monitoring and Adjusting">
  </div>
</section>

  
</div>
  


<section class="contact-us-section">
  <div class="contact-content">
    <h2>Contact Us  Today!</h2>
    <p class="slogan">Your journey to financial freedom starts here!</p>
  </div>

  <div class="contact-form-container"> 
    <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" class="contact-form">
      <h2>Submit Your Enquiry</h2>
      <input formControlName="full_name" type="text" placeholder="Your Name" required>
      <input formControlName="email" type="email" placeholder="Your Email" required>
      <input formControlName="phone" type="tel" placeholder="Your Phone Number" required>
      <input type="datetime-local" formControlName="appointment_date" id="appointmentDate" required>
      <textarea formControlName="enq_detail_msg" placeholder="Your Message" required></textarea>
      
      <button type="submit" [disabled]="enquiryForm.invalid">Send Message</button>
    </form>
  
    <!-- Standard message after submission -->

  <!-- Thank you message with animated smiley -->
  <div *ngIf="isEnquirySubmitted" class="thank-you-message animated">
    <h3>
      Thank you for your enquiry! We will get back to you shortly! 
      <span class="smiley">😊</span>
    </h3>
  </div>
  </div>
  
</section>



<app-footer></app-footer>
